import { render, staticRenderFns } from "./LotteryMenu.vue?vue&type=template&id=6b093eec&"
import script from "CJ/components/lotteryMenu.component?vue&type=script&lang=js&"
export * from "CJ/components/lotteryMenu.component?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports